import React from 'react';

import {Theme, withStyles} from '@material-ui/core/styles';

import DialogTitle from '@material-ui/core/DialogTitle';

import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import {Dialog, Typography} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/CloseTwoTone';
import PickerContainer from 'hcla-web-frontend-primitives/app/components/primitives/Picker/PickerContainer';
import IconButton from '@material-ui/core/IconButton/IconButton';
import createStyles from "@material-ui/core/styles/createStyles";
import HclApiManager from '../../../../../Api/HclApiManager';
import HCLTreeMxGraphView, {HCLTreeMxGraphViewJSON} from '../MxGraphViews/HCLTreeMxGraphView';
import HCLTreeVertex from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertex";
import {TreeTypes} from "../Tools/TreeDictionaries";
import HCLTreeMxGraphVertexPickerView from "../MxGraphViews/HCLTreeMxGraphVertexPickerView";

const styles = (theme: Theme) => createStyles({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }
});

interface Props {
  onClose: () => void;
  onSet?: (e: React.SyntheticEvent<{}, Event>, selectedVertex: HCLTreeVertex) => void;
  open: boolean;
  pickModelsOnly?: boolean;
  passGetModel?: (model: object) => void;
  treeTypes?: TreeTypes[];
  classes: any;
}

interface State {
  data: HCLTreeMxGraphViewJSON;
  selectedVertex: HCLTreeVertex;
  selectedModel: object;
}

class TreePickerDialog extends React.Component<Props, State> {
  constructor (props: Props) {
    super(props);
    this.state = {
      data: null,
      selectedVertex: null,
      selectedModel: null,
    };
  }

  private fetchTreeData = (id: number) => {
    HclApiManager.getHclTreeWithMetadata(id)
      .then((response: any) => response.ok && response.json())
      .then((data: HCLTreeMxGraphViewJSON) => {
        this.setState({ data });
      });
  };

  private handleClose = (e: React.SyntheticEvent<{}, Event>) => {
    const { onClose, onSet } = this.props;
    const { selectedVertex } = this.state;
    onSet(e, selectedVertex);
    this.setState({ data: null, selectedVertex: null }, onClose);
  };

  private handleCancel = () => {
    this.setState({ data: null, selectedVertex: null });
  };

  private handleVertexClick = (vertex: HCLTreeVertex) => {
    this.setState({ selectedVertex: vertex });
  };

  private setGetModel = (model: object) => {
    this.setState({ selectedModel: model });
  };

  private passGetModel = () => {
    const { passGetModel, onClose } = this.props;
    const { selectedModel } = this.state;
    const doPassGetModel = async () => {
      passGetModel(selectedModel);
    };
    doPassGetModel().then(() => onClose());
  };

  render() {
    const { data, selectedVertex, selectedModel } = this.state;
    const { classes, open, onClose, pickModelsOnly, treeTypes } = this.props;

    const treeTypesToShow = treeTypes || [TreeTypes.FAULT_TREE, TreeTypes.BAYESIAN_NETWORK];

    return (
      <Dialog
        fullWidth
        maxWidth={false}
        open={open}
        disablePortal
      >
        <DialogTitle>
          <div className={classes.root}>
            <Typography variant="h6" color="textPrimary">Picker</Typography>
            <div>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <PickerContainer
            pickModelsOnly={pickModelsOnly}
            updateDialogTreeId={(id: any) => this.fetchTreeData(id)}
            doGetModel={(model: object) => this.setGetModel(model)}
            validTreeTypes={treeTypesToShow}
          />
          <Dialog
            open={Boolean(data)}
            onClose={this.handleClose}
            fullWidth
            maxWidth={false}
            PaperProps={{ style: { height: '100vh', overflow: 'auto' } }}
            disablePortal
          >
            {
              data && (
                <HCLTreeMxGraphVertexPickerView
                  data={data}
                  basePath="/model"
                  onVertexClick={this.handleVertexClick}
                />
              )}
            <DialogActions>
              <Button
                fullWidth
                variant="contained"
                tabIndex={-1}
                onClick={this.handleCancel}
              >
                Cancel
              </Button>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                disabled={selectedVertex === null}
                onClick={this.handleClose}
              >
                Set
              </Button>
            </DialogActions>
          </Dialog>
        </DialogContent>
        {pickModelsOnly && (
          <DialogActions>
            <Button
              fullWidth
              variant="contained"
              tabIndex={-1}
              onClick={onClose}
            >
            Cancel
            </Button>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              disabled={selectedModel === null}
              onClick={this.passGetModel}
            >
            Set
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(TreePickerDialog);
